import { c as _c } from "react/compiler-runtime";
import { H3 } from '@/frontend/design-system/_marketing/typography/Heading';
import { cn } from '@/frontend/utils';
type CardProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;
export const MentoringCard = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = title;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    title = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("h-fit rounded-lg border-slate-300 border-b bg-backgroundPrimary", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== title) {
    t2 = <H3 className="rounded-t-lg border border-blue-300 bg-blue-50 p-6 text-center">{title}</H3>;
    $[7] = title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children) {
    t3 = <div className="rounded-b-lg border-slate-300 border-x p-4 lg:p-6">{children}</div>;
    $[9] = children;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className={t1} {...props}>{t2}{t3}</div>;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};